import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'brackets-off', 'BracketsOff', [["path",{"d":"M5 5v15h3"}],["path",{"d":"M16 4h3v11m0 4v1h-3"}],["path",{"d":"M3 3l18 18"}]]);